import React, { useState, useCallback, useEffect } from "react";
import './servicecalendar.css';
import '../../lib/request';
export const ServiceCalendarTitle = ({
    onRefreshDate
}) => {
    const [currentDate, setCurrentDate] = useState(new Date());
    const formatDate = (date) => {
        return date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        });
    };
    return (
        <div style={{ display: "flex", alignItems: "center" }} className="space">
            <h2>
                Scheduled Services
            </h2>
            <h2 style={{ paddingLeft: '5em', cursor: 'pointer', color: 'rgba(36, 119, 168, 1)' }}
                onClick={() => onRefreshDate(new Date())}
            >
                {formatDate(currentDate)}
            </h2>
        </div>
    );
};
